import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import { IModulesProps, IModulesState } from '../../models/pages/modules';
import { Log } from 'ng2-logger';
import { Link, Redirect } from 'react-router-dom';
import Switch from 'react-switch';
import Input from '../../components/input/text/input-formik';
import Select from 'react-select';
import { SketchPicker } from 'react-color';
import EducationModule from './education';
import ComunicationModule from './comunication';
import NotificationModule from './notification';



const T = Translator.create();
const _logger = Log.create('Gradebook - main.tsx');
let _common: Common;
const date = new Date()

if (T.i18next.language === 'tr') {
     moment.locale('tr');
} else if (T.i18next.language === 'en') {
     moment.locale('en');
}
else if (T.i18next.language === 'ar') {
     moment.locale('ar');
}

class CModulesPage extends React.Component<IModulesProps, IModulesState> {
     tabLabels: { [key: string]: { label: string; passive: boolean } } = {
          "v-pills-1": { label: `${T.t("r_education_modules")}`, passive: false },
          "v-pills-2": { label: `${T.t("r_communication_modules")}`, passive: false },
          "v-pills-3": { label: `${T.t("r_notification_modules")}`, passive: false },
          "v-pills-4": { label: `${T.t("r_report_modules")}`, passive: true },
          "v-pills-5": { label: `${T.t("r_stats_modules")}`, passive: true },
          "v-pills-6": { label: `${T.t("r_management_modules")}`, passive: true },
          "v-pills-7": { label: `${T.t("r_profile_modules")}`, passive: true }
      };


     constructor(props: IModulesProps) {
          super(props);
          _common = new Common();
     }
     state = {
          redirect: false,
          redirectUrl: "",
          activeTab: "v-pills-1",
     }

     handleTabClick = (tabId: string) => {
          this.setState({ activeTab: tabId});

     };


     public render() {
          const { activeTab  } = this.state;

          return (
               <div className="container-fluid  mx-0 ">
                    <div className="row " style={{ minHeight: 'calc(100vh - 55px)' }}>
                         {/* Modül kategori Listesi */}
                         <div className="col-md-2 col-12" style={{ background: 'rgba(0,0,0,.04) ' }}>
                              <ul className="settings_header_list" role="tablist" aria-orientation="vertical">
                                   {Object.keys(this.tabLabels).map((key) => {
                                        const { label, passive } = this.tabLabels[key];
                                        return (
                                             <li
                                                  key={key}
                                                  className={`${activeTab === key ? "active" : ""} ${passive ? "passive" : ""}`}
                                                  onClick={() => !passive && this.handleTabClick(key)}
                                                  id={`${key}-tab`}
                                                  data-toggle="pill"
                                                  data-target={`#${key}`}
                                                  role="tab"
                                                  aria-controls={key}
                                                  aria-selected={activeTab === key}
                                             >
                                                  <span className='module_icon'>{label}</span>
                                             </li>
                                        );
                                   })}
                              </ul>
                         </div>

                         {/* Modül içeriği kısmı */}
                         <div className="col-md-10 col-12 "  >
                              <div className='tab-content' id="v-pills-tabContent">
                                   {/* Eğitim modülleri */}
                                   <div className={`tab-pane fade ${activeTab === "v-pills-1" ? "show active" : ""}`} id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-1-tab">
                                        <EducationModule />
                                   </div>

                                   {/* İletişim modülleri */}
                                   <div className={`tab-pane fade ${activeTab === "v-pills-2" ? "show active" : ""}`} id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab">
                                        <ComunicationModule />
                                   </div>

                                   {/* Bildirim modülleri */}
                                   <div className={`tab-pane fade ${activeTab === "v-pills-3" ? "show active" : ""}`} id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab">
                                        <NotificationModule />
                                   </div>




                              </div>
                         </div>
                    </div>


               </div >
          );
     }
}

const mapStateToProps = (state: IAppState, ownProps: IModulesProps): IModulesProps => {
     if (!state) {
          return ownProps;
     }

     const newProps: IModulesProps = Object.assign({}, ownProps, {
     });
     return newProps;
};

const ModulesPage = connect(
     mapStateToProps,
)(CModulesPage);

export default ModulesPage;
